/*
 *
 * !!! DO NOT MODIFY DIRECTLY !!!
 *
 * @generated via scripts/import-icons
 *
 */

import React from 'react'

import { CssVars } from '../../../themes'
import { TextColorOverride } from '../../TextColorOverride'

export function PhoneConnected16({
  color,
}: {
  color?: React.ComponentProps<typeof TextColorOverride>['color']
}) {
  const node = (
    <svg
      fill="none"
      height="16"
      role="img"
      viewBox="0 0 16 16"
      width="16"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.2 10.8c2.2 2.1 5 3.2 7.8 3.2l.9-1.1v-1.8c0-.3-.2-.5-.5-.5-1.4 0-2.4-.4-2.9-.6-.1-.1-.4 0-.5.1l-1.1 1.1c-.8-.4-1.7-1-2.4-1.7S5.2 8 4.8 7.1L5.9 6c.1-.2.1-.4.1-.6-.2-.4-.6-1.4-.7-2.9 0-.3-.2-.5-.5-.5H3L2 3c0 2.8 1.1 5.6 3.2 7.8Z"
        fill={CssVars.textColor}
      />
      <path
        d="M11.034 8.084a5.961 5.961 0 0 1-.982-.539C9.04 6.855 8.398 5.93 7.99 4.963l-.005-.012a2.6 2.6 0 0 1 3.05 3.133Z"
        fill={CssVars.textColor}
      />
      <path
        d="M12.37 8.514A4.005 4.005 0 0 0 7.56 3.61a9.582 9.582 0 0 1-.213-1.49 5.5 5.5 0 0 1 6.517 6.602 9.857 9.857 0 0 1-1.494-.21Z"
        fill={CssVars.textColor}
      />
    </svg>
  )
  return color ? (
    <TextColorOverride color={color}>
      {({ rootClassName }) => (
        // NOTE(jare): Since the svg node's display is "inline", it can be
        // rendered with a little whitespace around it in certain cases. We
        // wrap it in a flexbox container to remove that whitespace.
        <span className={rootClassName} css={{ display: 'inline-flex' }}>
          {node}
        </span>
      )}
    </TextColorOverride>
  ) : (
    node
  )
}
